<!-- @format -->
<template>
    <div class="journey-template-select-widget">
        <div class="widget-contents-container">
            <div class="widget-header">
                <h3>Choose Journey</h3>
                <div class="svg-container widget-close-button" @click="closeWidget">
                    <widget-close-svg />
                </div>
            </div>
            <div class="content-wrapper">
                <div class="templates-container">
                    <journey-template-select-display
                        multiselector
                        primary
                        :initialSelectedItems="initialSelectedItems"
                        @select="select"
                    />
                </div>
            </div>
            <div class="widget-footer">
                <div class="cancel-container">
                    <app-button class="cancel-btn" @click="closeWidget">Cancel</app-button>
                </div>
                <div class="action-container">
                    <app-button @click="add()">Add</app-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const AppButton = () => import('@/components/common/app-button');
const WidgetCloseSvg = () => import('@/components/svg/quick-add/widget-close-svg');
const JourneyTemplateSelectDisplay = () =>
    import('@/components/journey/journey-template-select-display');

import EventBus from '@/scripts/event-bus.js';

export default {
    name: 'journey-template-select-widget',

    components: {
        'widget-close-svg': WidgetCloseSvg,
        'app-button': AppButton,
        'journey-template-select-display': JourneyTemplateSelectDisplay,
    },

    props: {
        widget: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            allowMultipleSelections: this.widget.allowMultipleSelections || false,
            selectedItems: [],
            initialSelectedItems: [],
        };
    },

    created() {
        if (this.widget.initialSelectedIds) {
            this.initialSelectedItems = this.widget.initialSelectedIds.map((id) => {
                return { id: id };
            });
        }
    },

    methods: {
        closeWidget() {
            EventBus.$emit('close-widget', this.widget);
        },

        select(items) {
            this.selectedItems = items;
        },

        add() {
            EventBus.$emit(
                'journey-template:select',
                this.selectedItems.map((item) => item.id)
            );
            this.closeWidget();
        },
    },
};
</script>

<style>
.journey-template-select-widget .action-container .save-btn {
    width: 128px;
}

.journey-template-select-widget .action-container .back-btn {
    width: 128px;
    background: transparent;
    color: #18aeff;
    margin-right: 10px;
}

.journey-template-select-widget .action-container .back-btn:hover {
    background: #e1e0e5;
}

.journey-template-select-widget .cancel-btn {
    background: transparent;
    color: #877d88;
    border: none;
}

.journey-template-select-widget .cancel-btn:hover {
    background: #e9e9ef;
}

.journey-template-select-widget .templates-container {
    padding: 25px 0px 0px 0px;
}
</style>
